import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import FilterModal from "../Filter Modal/FilterModal";
import axios from "axios";

export default function DataTable_Component({
  apidata,
  columns,
  searchBy,
  totalRows,
  currentPage,
  setCurrentPage,
  rowsPerPage,
  setRowsPerPage,
  dataFilter,
  setDataFilter,
  statusFilter,
  setStatusFilter,
  vendorFilter,
  setVendorFilter,
}) {
  const [showFilterModal, setShowFilterModal] = useState(false);
  const [vendors, setVendors] = useState([]);
  useEffect(() => {
    const fetchVendors = async () => {
      try {
        const token = localStorage.getItem("token");

        const res = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/api/v1/vendors`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );

        setVendors(res.data.vendors || []);
      } catch (err) {
        console.error("Vendor fetch error", err);
      }
    };

    fetchVendors();
  }, []);
  const applyFilters = () => {
    setCurrentPage(1);
    setShowFilterModal(false);
  };

  const removeFilters = () => {
    setStatusFilter("");
    setVendorFilter("");
    setShowFilterModal(false);
  };

  return (
    <div className="table-responsive">
      <div className="row justify-content-between mb-2">
        <div className="col-md-3 mb-2">
          <input
            type="text"
            placeholder={`Search by ${searchBy}`}
            className="form-control"
            value={dataFilter}
            onChange={(e) => {
              setDataFilter(e.target.value);
            }}
          />
        </div>
        <div className="col-md-9 mb-2">
          <button
            className="btn btn-primary"
            onClick={() => setShowFilterModal(true)}
          >
            Filter
          </button>
        </div>
      </div>
      <DataTable
        columns={columns}
        data={apidata}
        pagination
        paginationServer
        paginationTotalRows={totalRows}
        paginationPerPage={rowsPerPage}
        paginationRowsPerPageOptions={[5, 10, 15, 20]}
        paginationDefaultPage={currentPage}
        onChangePage={(page) => setCurrentPage(page)}
        onChangeRowsPerPage={(newPerPage) => {
          setRowsPerPage(newPerPage);
        }}
        fixedHeader
        highlightOnHover
        responsive
      />

      <FilterModal
        show={showFilterModal}
        onHide={() => setShowFilterModal(false)}
        statusFilter={statusFilter}
        setStatusFilter={setStatusFilter}
        applyFilters={applyFilters}
        removeFilters={removeFilters}
        apidata={apidata}
        vendorFilter={vendorFilter}
        setVendorFilter={setVendorFilter}
        vendors={vendors}
      />
    </div>
  );
}
